


















import { Component, Prop, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import ContentMixin from "@/mixins/ContentMixin";

@Component({
  name: "img-container",
})
export default class ImgContainer extends mixins(ContentMixin) {
  @Prop({ default: "" })
  public src!: string;

  @Prop({ default: true })
  public hasZoom!: boolean;

  public zoomImage(ref: string, type: string) {
    const element: any = this.$refs["zoom-img-" + ref];

    if (type === "remove") {
      element.classList.remove("do-zoom");
    } else {
      element.classList.add("do-zoom");
    }
  }

  public onMouseEnterOption(option: string) {
    this.$emit("zoom:over", true);
  }

  public onMouseLeaveOption(option: string) {
    this.$emit("zoom:over", false);
  }
}
